import React, { useState } from 'react';
import LoadingModal from '../Components/AllModal/LoadingModal';
import * as XLSX from 'xlsx';
import Coursera from '../utils/courseraAxiosConfig';

function InvitesUserInCoursera() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    
    reader.onload = async (event) => {
      const bstr = event.target.result;
      const workbook = XLSX.read(bstr, { type:'binary' });
      
      // Get first worksheet
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      
      // Convert to array of objects
      const data = XLSX.utils.sheet_to_json(worksheet);
      setItems(data);
      console.log(data, "==users:coursera");
      try {
        // const res = await Coursera.post("", { users: data });
        // console.log(res.data, "resss.data:InvitesUserInCoursera");
      } catch (error) {
        console.log(error, "error:InvitesUserInCoursera");
      }
    };
    
    reader.readAsBinaryString(file);
  }


  return (
    <div>
      {loading && <LoadingModal className="bg-gray-500/80" />}
      <input type="file" accept=".xlsx, .xls" onChange={handleFile} />
      <div className='min-h-screen overflow-auto'>
        Data read from Excel:
        <pre>{JSON.stringify(items, null, 2)}</pre>
      </div>
    </div>
  );
}

export default InvitesUserInCoursera;
